import { render, staticRenderFns } from "./global-forms-card.vue?vue&type=template&id=04a82219&scoped=true&"
import script from "./global-forms-card.vue?vue&type=script&lang=js&"
export * from "./global-forms-card.vue?vue&type=script&lang=js&"
import style0 from "./global-forms-card.vue?vue&type=style&index=0&id=04a82219&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a82219",
  null
  
)

export default component.exports